import { Grid, useMediaQuery } from "@mui/material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { IStakingRuleExt } from "./view";
import { StakingRulesSearchForm } from "./search";
import { StakingRulesItem } from "./item";

const STAKING_RULES_URL = "/staking/rules";

export const StakingRules = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IStakingRuleExt>
  >(STAKING_RULES_URL, { enableInfiniteScroll: isMd });

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "staking", "staking.rules"]} />

      <PageHeader message="pages.staking.rules.title" />
      <StakingRulesSearchForm />
      <ProgressOverlay isLoading={isLoading}>
        <Grid container size={12} spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(rule => (
              <StakingRulesItem key={rule.id} rule={rule} />
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Grid>
  );
};
